import cuBoulderImg from "../assets/img/cu-boulder-campus.webp";

export const education = {
  school: "University of Colorado at Boulder",
  image: cuBoulderImg,
  details: [
    { label: "Major", value: "Computer Science" },
    { label: "Minor", value: "Technology, Arts & Media" },
    { label: "GPA", value: "3.4" },
  ],
};

export default education;
